/* import __COLOCATED_TEMPLATE__ from './loading-error.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    title: string;
    text: string;
    retry: () => void;
  };
}

const LoadingError = templateOnlyComponent<Signature>();
export default LoadingError;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::LoadingError': typeof LoadingError;
    'inbox2/conversations-table/loading-error': typeof LoadingError;
  }
}
